"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.syncDocumentTranslations = exports.getSupportLink = exports.localizeLink = exports.getTwoCharacterCountryCodeFromLanguage = exports.regionalMappings = exports.countryCodeReplacementString = exports.ptcsRegions = exports.defaultI18NextOptions = exports.fallbackLng = exports.supportedLngs = exports.DEFAULT_SUPPORTEDLNGS = void 0;
function useTraditional(subTags) {
    if (subTags.includes('Hant')) {
        return true;
    }
    else if (subTags.includes('Hans')) {
        return false;
    }
    else if (subTags.includes('HK') || subTags.includes('TW') || subTags.includes('MO')) {
        return true;
    }
    return false;
}
exports.DEFAULT_SUPPORTEDLNGS = ['da', 'de', 'en', 'es', 'fi', 'fr', 'it', 'ja', 'nb', 'no', 'nn', 'nl', 'pt', 'ru', 'sv'];
function supportedLngs(defaultLngs, addPseudo) {
    if (defaultLngs === void 0) { defaultLngs = exports.DEFAULT_SUPPORTEDLNGS; }
    if (addPseudo === void 0) { addPseudo = true; }
    var supportedLngs = defaultLngs.slice();
    // eslint-disable-next-line dot-notation
    var stage = process.env['REACT_APP_STAGE'] || '';
    if (stage !== 'live' && !stage.startsWith('ci-') && addPseudo) {
        // Add 'pseudo' to lower envs and development
        supportedLngs.push('pseudo');
    }
    return supportedLngs;
}
exports.supportedLngs = supportedLngs;
function fallbackLng(code) {
    var fallbacks = [];
    if (code) {
        // Split up the language into component parts
        var langParts = code.split('-');
        var lng = langParts[0];
        var subTags = langParts.slice(1);
        subTags.map(function (tag) { return tag.toUpperCase(); });
        if (lng) {
            if (lng.startsWith('nb') || lng.startsWith('nn') || lng.startsWith('no')) {
                fallbacks.push('nb-NO'); // change this if we ever add real support for Nynorsk
            }
            else if (lng === 'zh') {
                // Chinese rules are complicated enough to get their own helper function
                if (useTraditional(subTags)) {
                    fallbacks.push('zh-Hant');
                }
                else {
                    fallbacks.push('zh-Hans');
                }
            }
            else if (lng === 'pt') {
                // All we have is brazilian portuguese
                fallbacks.push('pt-BR');
            }
            else if (lng === 'es') {
                // We use Latin American Spanish for all country codes other than Spain
                if (subTags.length === 0 || !subTags.includes('ES')) {
                    fallbacks.push('es-XL');
                }
                else {
                    fallbacks.push('es');
                }
            }
            else
                fallbacks.push(lng);
        }
    }
    // fallback to source language if it isn't already in the fallback list
    if (!fallbacks.includes('en')) {
        fallbacks.push('en');
    }
    // finally, fallback to the developer language
    fallbacks.push('dev');
    return fallbacks;
}
exports.fallbackLng = fallbackLng;
exports.defaultI18NextOptions = {
    debug: false,
    detection: {
        // order and from where user language should be detected
        order: ['querystring', 'sessionStorage', 'navigator'],
        // keys or params to lookup language from
        lookupSessionStorage: 'lng'
    },
    fallbackLng: fallbackLng,
    interpolation: {
        escapeValue: false
    },
    keySeparator: false,
    load: 'currentOnly',
    nonExplicitSupportedLngs: true,
    supportedLngs: supportedLngs(),
    returnEmptyString: false
};
exports.ptcsRegions = ['el', 'br', 'us', 'dk', 'fi', 'fr', 'de', 'it', 'nl', 'no', 'ru', 'se', 'jp', 'es', 'uk'];
var fallbackTable = {
    'es-xl': 'el',
    'es-419': 'el',
    'pt-br': 'br',
    'en-us': 'us',
    'da-dk': 'dk',
    'fi-fi': 'fi',
    'fr-fr': 'fr',
    'de-de': 'de',
    'it-it': 'it',
    'nl-nl': 'nl',
    'nb-no': 'no',
    'ru-ru': 'ru',
    'es-es': 'es',
    'sv-se': 'se',
    'en-gb': 'uk',
    'en-ie': 'uk',
    'en-uk': 'uk',
    'en-au': 'uk',
    'ja-jp': 'jp'
};
var twoCharFallback = {
    es: 'el',
    br: 'br',
    en: 'us',
    da: 'dk',
    fi: 'fi',
    fr: 'fr',
    de: 'de',
    it: 'it',
    nl: 'nl',
    nb: 'no',
    nn: 'no',
    no: 'no',
    ru: 'ru',
    sv: 'se',
    ja: 'jp',
    pt: 'br'
};
exports.countryCodeReplacementString = 'COUNTRYCODE';
var miscellaneousGlobalMappings = {
    'club.beta2': 'club-beta2',
    'club.stable': 'club-stable'
};
/**
 * URLs supported:
 * - Terms of Use: https://www.pokemon.com/us/terms-of-use/
 * - Privacy Policy: https://www.pokemon.com/us/privacy-notice/
 * - Forgot Username: https://club.pokemon.com/us/pokemon-trainer-club/forgot-username
 * - Forgot Password: https://club.pokemon.com/us/pokemon-trainer-club/forgot-password
 * - Sign Up: https://club.pokemon.com/us/pokemon-trainer-club/sign-up/
 * - Awaiting Activation: https://club.pokemon.com/us/pokemon-trainer-club/awaiting
 * - My Play! Pokémon: https://www.pokemon.com/us/pokemon-trainer-club/play-pokemon/events/
 * - Play! Pokémon Leaderboards: https://www.pokemon.com/us/play-pokemon/leaderboards/
 */
exports.regionalMappings = {
    el: {
        'pokemon-trainer-club': 'club-de-entrenadores-pokemon',
        'sign-up': 'registro',
        'terms-of-use': 'terminos-de-uso',
        'privacy-notice': 'aviso-sobre-la-privacidad',
        awaiting: 'en-espera',
        '/play-pokemon/events': '/play-pokemon/eventos',
        '/play-pokemon/leaderboards': '/play-pokemon/listas-de-clasificacion',
        '/play-pokemon/about/play-points': '/play-pokemon/sobre/play-points',
        '/play-pokemon/pokemon-events/pokemon-tournaments/earn-championship-points-tcg': '/play-pokemon/eventos-pokemon/torneos-pokemon/ganar-championship-points-de-jcc'
    },
    es: {
        'pokemon-trainer-club': 'club-de-entrenadores-pokemon',
        'sign-up': 'registro',
        'terms-of-use': 'condiciones-de-uso',
        'privacy-notice': 'aviso-de-privacidad',
        awaiting: 'en-espera',
        '/play-pokemon/events': '/play-pokemon/eventos',
        '/play-pokemon/leaderboards': '/play-pokemon/listas-de-clasificacion',
        '/play-pokemon/about/play-points': '/play-pokemon/sobre/play-points',
        '/play-pokemon/pokemon-events/pokemon-tournaments/earn-championship-points-tcg': '/play-pokemon/eventos-pokemon/torneos-pokemon/ganar-championship-points-de-jcc'
    },
    fr: {
        'pokemon-trainer-club': 'club-des-dresseurs-pokemon',
        'sign-up': 'inscription',
        'terms-of-use': 'conditions-d-utilisation',
        'privacy-notice': 'avis-de-confidentialite',
        awaiting: 'attente',
        '/play-pokemon/events': '/play-pokemon/evenements',
        '/play-pokemon/leaderboards': '/play-pokemon/classements',
        '/play-pokemon/about/play-points': '/play-pokemon/a-propos/play-points',
        '/play-pokemon/pokemon-events/pokemon-tournaments/earn-championship-points-tcg': '/play-pokemon/evenements-pokemon/tournois-pokemon/remporter-des-championship-points-jcc'
    },
    it: {
        'pokemon-trainer-club': 'club-allenatori-di-pokemon',
        'sign-up': 'iscriviti',
        'terms-of-use': 'termini-di-utilizzo',
        'privacy-notice': 'informativa-sulla-privacy',
        awaiting: 'in-attesa',
        '/play-pokemon/events': '/play-pokemon/eventi',
        '/play-pokemon/leaderboards': '/play-pokemon/classifiche',
        '/play-pokemon/about/play-points': '/play-pokemon/info/play-point',
        '/play-pokemon/pokemon-events/pokemon-tournaments/earn-championship-points-tcg': '/play-pokemon/eventi-pokemon/tornei-pokemon/gcc-guadagna-championship-point'
    },
    de: {
        'sign-up': 'anmelden',
        'terms-of-use': 'nutzungsbedingungen',
        'privacy-notice': 'datenschutzerklaerung',
        awaiting: 'erwartend',
        '/play-pokemon/events': '/play-pokemon/veranstaltungen',
        '/play-pokemon/leaderboards': '/play-pokemon/ranglisten',
        '/play-pokemon/about/play-points': '/play-pokemon/ueber/play-points',
        '/play-pokemon/pokemon-events/pokemon-tournaments/earn-championship-points-tcg': '/play-pokemon/pokemon-veranstaltungen/pokemon-turniere/verdiene-championship-points-sammelkartenspiel'
    },
    br: {
        'pokemon-trainer-club': 'clube-de-treinadores-pokemon',
        'sign-up': 'registro',
        'terms-of-use': 'termos-de-uso',
        'privacy-notice': 'aviso-de-privacidade',
        awaiting: 'aguardando',
        '/play-pokemon/events': '/play-pokemon/eventos',
        '/play-pokemon/leaderboards': '/jogar-pokemon/placares-de-lideranca',
        '/play-pokemon/about/play-points': '/play-pokemon/info/play-point',
        '/play-pokemon/pokemon-events/pokemon-tournaments/earn-championship-points-tcg': '/play-pokemon/eventos-pokemon/torneios-pokemon/consiga-championship-points-de-tcg'
    },
    dk: {
        'pokemon-trainer-club': 'pokemon-traener-klub',
        'sign-up': 'log-ind',
        'terms-of-use': 'betingelser-for-brug',
        'privacy-notice': 'fortrolighedspolitik',
        awaiting: 'venter',
        '/play-pokemon/events': '/spil-pokemon/events',
        '/play-pokemon/leaderboards': '/spil-pokemon/pointtavler'
        // points urls are the same for dk
    },
    fi: {
        'pokemon-trainer-club': 'pokemon-kouluttajien-kerho',
        'sign-up': 'rekisterointi',
        'terms-of-use': 'kayttoehdot',
        'privacy-notice': 'tietosuojailmoitus',
        awaiting: 'odottaa',
        '/play-pokemon/events': '/pelaa-pokemon/tapahtumat',
        '/play-pokemon/leaderboards': '/pelaa-pokemon/tulostaulukot'
        // points urls are the same for fi
    },
    nl: {
        'pokemon-trainer-club': 'pokemon-trainerclub',
        'sign-up': 'registreren',
        'terms-of-use': 'gebruiksvoorwaarden',
        'privacy-notice': 'privacyverklaring',
        awaiting: 'wachten',
        '/play-pokemon/events': '/pokemon-spelen/evenementen',
        '/play-pokemon/leaderboards': '/pokemon-spelen/klassementen'
        // points urls are the same for nl
    },
    no: {
        'pokemon-trainer-club': 'pokemon-trener-klubb',
        'sign-up': 'registrer',
        'terms-of-use': 'vilkar-for-bruk',
        'privacy-notice': 'retningslinjer-for-personvern',
        awaiting: 'ventende',
        '/play-pokemon/events': '/spill-pokemon/hendelser',
        '/play-pokemon/leaderboards': '/spill-pokemon/poengtavler',
        '/play-pokemon/about/play-points': '/play-pokemon/om/play-poeng',
        '/play-pokemon/pokemon-events/pokemon-tournaments/earn-championship-points-tcg': '/play-pokemon/pokemon-arrangementer/pokemon-turneringer/vinn-mesterskaps-poeng-tcg'
    },
    se: {
        'pokemon-trainer-club': 'pokemon-tranarklubb',
        'sign-up': 'registrera-dig',
        'terms-of-use': 'villkor-foer-anvaendning',
        'privacy-notice': 'sekretesspolicy',
        awaiting: 'vantar',
        '/play-pokemon/events': '/play-pokemon/evenemang',
        '/play-pokemon/leaderboards': '/spela-pokemon/ledartavlor'
        // points urls are the same for se
    }
    // URLs appear to be identical to the US for uk, jp, and ru.
};
var getTwoCharacterCountryCodeFromLanguage = function (language) {
    if (!language)
        return "us";
    var lowercaseLanguage = language.toLowerCase();
    return fallbackTable[lowercaseLanguage] || twoCharFallback[lowercaseLanguage] || twoCharFallback[lowercaseLanguage.substring(0, 2)] || "us";
};
exports.getTwoCharacterCountryCodeFromLanguage = getTwoCharacterCountryCodeFromLanguage;
var localizeLink = function (language, linkWithCountryCode) {
    var country = exports.getTwoCharacterCountryCodeFromLanguage(language);
    var updatedLink = linkWithCountryCode.replace(exports.countryCodeReplacementString, country);
    var globalKeys = Object.keys(miscellaneousGlobalMappings);
    for (var i = 0; i < globalKeys.length; i++) {
        var key = globalKeys[i]; // the lack of ES6 syntax in this project makes me sad :(
        updatedLink = updatedLink.replace(key, miscellaneousGlobalMappings[key]);
    }
    var regionalKeys = Object.keys(exports.regionalMappings[country] || {});
    for (var i = 0; i < regionalKeys.length; i++) {
        var key = regionalKeys[i];
        updatedLink = updatedLink.replace(key, exports.regionalMappings[country][key]);
    }
    return updatedLink;
};
exports.localizeLink = localizeLink;
var supportLanguageTable = {
    en: 'en-us',
    de: 'de',
    es: 'es',
    fr: 'fr',
    it: 'it',
    pt: 'pt-br',
    ru: 'ru',
    no: 'no',
    fi: 'fi',
    sv: 'sv',
    nl: 'nl',
    da: 'da'
};
var getSupportLink = function (language) {
    var supportLang;
    if (language) {
        var lowercaseLanguage = language.toLowerCase();
        supportLang = supportLanguageTable[lowercaseLanguage] || supportLanguageTable[lowercaseLanguage.substring(0, 2)];
    }
    if (!supportLang) {
        supportLang = 'en-us';
    }
    return "https://support.pokemon.com/hc/" + supportLang;
};
exports.getSupportLink = getSupportLink;
var syncDocumentTranslations = function (i18n, getTitle) {
    i18n.on('languageChanged', function () {
        document.documentElement.lang = i18n.language;
        document.title = getTitle();
    });
};
exports.syncDocumentTranslations = syncDocumentTranslations;
